/* DIY PRINTZ — Contract Cart: Print Box Label banner
 *
 * On the /cart page, if the cart carries our contract-order attributes,
 * inject a big "Print Box Label" call-to-action at the top of the cart.
 * Reads params from /cart.js attributes and opens /pages/box-label in a
 * new tab with the job info as URL params.
 *
 * Also self-scopes to the /cart URL so we can safely include this script
 * site-wide without any cost on other pages.
 */
(function () {
  if (!/^\/cart\/?(\?|$)/.test(location.pathname + location.search)) return;

  async function init() {
    let cart;
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      cart = await res.json();
    } catch (e) {
      return;
    }
    const attrs = cart.attributes || {};
    if (attrs.contract_order !== 'true') return;

    const job      = (attrs.contract_job      || '').trim();
    const po       = (attrs.contract_po       || '').trim();
    const company  = (attrs.contract_company  || '').trim();
    const contact  = (attrs.contract_contact  || '').trim();
    const dropoff  = (attrs.contract_dropoff  || '').trim();
    const garments = (attrs.contract_garments || '0').trim();
    const token    = (attrs.contract_token    || '').trim();
    const woUrl    = (attrs.contract_workorder_url || '').trim();

    if (!job && !company && !po) return;

    const params = new URLSearchParams({
      job, po, company, contact, dropoff, garments, token
    });
    const boxLabelUrl = '/pages/box-label?' + params.toString();

    // Build the banner
    const wrap = document.createElement('div');
    wrap.className = 'ccpl-banner';
    wrap.innerHTML = `
      <div class="ccpl-inner">
        <div class="ccpl-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="square" stroke-linejoin="miter">
            <path d="M7 8h10v-4h-10z"/>
            <path d="M4 14h16v-6h-16z"/>
            <path d="M7 14v6h10v-6"/>
            <path d="M9 17h6"/>
          </svg>
        </div>
        <div class="ccpl-text">
          <div class="ccpl-title">PRINT YOUR BOX LABEL</div>
          <div class="ccpl-sub">Tape this label to the outside of the box of apparel you're dropping off.</div>
          <div class="ccpl-meta">
            <span><strong>${escapeHtml(job || '—')}</strong></span>
            ${po ? `<span>PO ${escapeHtml(po)}</span>` : ''}
            <span>${escapeHtml(garments)} garments</span>
            ${dropoff ? `<span>drop-off ${escapeHtml(fmtDate(dropoff))}</span>` : ''}
          </div>
        </div>
        <div class="ccpl-actions">
          <a href="${boxLabelUrl}" target="_blank" rel="noopener" class="ccpl-btn ccpl-btn-primary">
            PRINT BOX LABEL
          </a>
          ${woUrl ? `<a href="${woUrl}" target="_blank" rel="noopener" class="ccpl-btn ccpl-btn-secondary">VIEW WORK ORDER</a>` : ''}
        </div>
      </div>
    `;

    // Insert at the very top of the cart page's <main> (or body if none)
    const main = document.querySelector('main') || document.body;
    if (main.firstChild) {
      main.insertBefore(wrap, main.firstChild);
    } else {
      main.appendChild(wrap);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c =>
      ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]
    );
  }

  function fmtDate(d) {
    if (!d) return '';
    try {
      const dt = new Date(d + 'T00:00:00');
      if (isNaN(dt.getTime())) return d;
      return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    } catch (e) { return d; }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
